<script setup lang="ts">
import { DataSourceLookup, GridButton } from '@/components';
import type { SelectLineValueType } from '@/objects';
import type { StartingNumber } from '@/objects/generated';
import type { ISelectLineDatasource } from '@/objects/ISelectLineDatasource';
import { useContestantStore } from '@/stores';
import { OpenContestantModal } from '@/utilities';

const props = withDefaults(
    defineProps<{
        value: SelectLineValueType;

        datasource: ISelectLineDatasource;

        row: StartingNumber;

        addAction: (row: StartingNumber) => void;
    }>(),
    {},
);

const openContestantDialog = () => {
    if (props.value) {
        const constestant = useContestantStore().GetContestantById(props.value as number);
        const id = constestant?.RaceContestants?.[0]?.ID;
        if (!id) {
            return;
        }
        OpenContestantModal({
            raceContestantId: id,
        });
    }
};
</script>
<template>
    <div class="d-flex align-items-center gap-1">
        <GridButton
            v-if="value"
            @click="openContestantDialog"
            text=""
            :row="row"
            icon="fa-user"
        />
        <DataSourceLookup
            v-if="value"
            :value="value"
            :datasource="datasource"
            :hideCaret="true"
        />
        <GridButton
            v-else
            buttonType="Add"
            @click="addAction(row)"
            text="general.add"
            :row="row"
            icon="fa-user-plus"
        />
    </div>
</template>
